import React from 'react'
import { t } from 'i18next'
import { Divider } from 'components/divider'
import { EyeIcon, ArrowLeftIcon, EllipsisVerticalIcon, ListBulletIcon } from '@heroicons/react/20/solid'
import { useNavigate } from 'react-router-dom'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/table'
import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu } from 'components/dropdown'
import { ErrorDialog, SuccessDialog } from 'components/custom/ResponseDialog'
import { GraphQlResponseNoData } from 'components/custom/GraphQlResponseDisplay'
import { useState, useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import { GET_VESSEL_CHECKLIST_SUBMISSION_LIST } from 'graphql/operations/queries'
import loadingImage from '../../../assets/images/boat-loading.gif'
import Flatpickr from 'react-flatpickr'
import { Pagination, PaginationList, PaginationNext, PaginationPage, PaginationPrevious } from 'components/pagination'
import { BoatNameDropdown } from 'components/custom/BoatNameDropdown'
import { UserListDropdown } from 'components/custom/userListDropdown'
import { customDateFormat } from 'utils/common'
import moment from 'moment'
import { getPageRange } from 'utils/paginationHelper'

export default function CheckLists() {
    const navigate = useNavigate()

    const [isSearch, setIsSearch] = useState(true)
    const { filterObj: initialFilterObj } = {}
    const [filterObj, setFilterObj] = useState(
        initialFilterObj || {
            boatID: null,
            submittedBy: null,
            dateFrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
        }
    )

    // Dialog Message
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')
    //
    const [checkLists, setCheckList] = useState([])
    const [routeCount, setRouteCount] = useState(0)

    // pagination
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const totalPages = Math.ceil(routeCount / rowsPerPage)

    const [getCheckList, { loading: checkListLoading, error: checkListError }] = useLazyQuery(
        GET_VESSEL_CHECKLIST_SUBMISSION_LIST,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                setIsSearch(false)
                if (data.getVesselChecklistSubmission.success && data.getVesselChecklistSubmission.code === '200') {
                    setCheckList(data.getVesselChecklistSubmission.submissions)
                    setRouteCount(data.getVesselChecklistSubmission.total_count)
                }
            },
        }
    )
    useEffect(() => {
        if (isSearch) {
            searchBoatCheckList()
        }
    }, [isSearch, page, rowsPerPage])

    const handlePageChange = newPage => {
        setIsSearch(true)
        console.log('new handlePageChange===', newPage)
        setPage(newPage)
    }
    // Search Route  List
    const searchBoatCheckList = () => {
        console.log('searchBoatCheckList=====', filterObj)
        const currentDate = new Date()
        currentDate.setMonth(currentDate.getMonth() - 1)
        const monthBeforeDate = currentDate.toLocaleDateString('en-CA').replace(/-/g, '-')
        getCheckList({
            variables: {
                page: {
                    limit: rowsPerPage,
                    offset: page * rowsPerPage,
                },
                toDate: filterObj.dateTo || new Date().toLocaleDateString('en-CA').replace(/-/g, '-'),
                fromDate: filterObj.dateFrom || monthBeforeDate,
                boatId: filterObj.boatID == 'ALL' ? null : filterObj.boatID,
                captainId: filterObj.submittedBy == 'ALL' ? null : filterObj.submittedBy,
            },
        })
    }

    const onClickSearch = () => {
        setPage(0)
        setRowsPerPage(10)
        setIsSearch(true)
    }
    const onClickSearchClear = () => {
        setFilterObj({
            boatID: 'ALL',
            boatNumber: null,
            submittedBy: 'ALL',
            dateFrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
        })
        setPage(0)
        setRowsPerPage(10)
        setIsSearch(true)
    }
    const handleErrClose = () => {
        setShowErrDialog(false)
        setErrorMessage('')
    }
    return (
        <>
            <div className="mb-6 flex justify-between items-center">
                <button
                    onClick={() => {
                        navigate('/')
                    }}
                    type="button"
                    className="inline-flex items-center gap-x-1.5 rounded-md text-sm"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-5 rtl:rotate-180" />
                    {t('Home')}
                </button>
            </div>

            <div className="flex flex-wrap items-end justify-between gap-4">
                <div className="max-sm:w-full sm:flex-1">
                    <div>
                        <div className="flex flex-wrap items-center gap-6 sm:flex-nowrap justify-between">
                            <div className="flex flex-wrap items-center gap-6 sm:flex-nowrap">
                                <h1 className="text-base font-semibold leading-7 text-gray-900 flex items-center">
                                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10 bg-[#e9eff1] w-[40px] h-[40px]">
                                        <ListBulletIcon className="w-[20px] h-[20px] fill-[#285f74]" />
                                    </div>
                                    <div>
                                        <span className="ms-3"> {t('Checklists')}</span>
                                        <p className="ms-3 text-sm font-normal leading-6 weight-[200] text-gray-500">
                                            {t(' View the checklist updated by the captain.')}
                                        </p>
                                    </div>
                                </h1>
                            </div>
                            <div className="flex flex-wrap items-center gap-6 sm:flex-nowrap"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-12/12 xl:w-9/12 mt-4 mb-4 flex flex-col sm:flex-row gap-4">
                <div className="w-12/12 md:w-4/12">
                    <label htmlFor="country" className="block text-sm font-medium leading-6 text-gray-900">
                        {t('Boat Name')}
                    </label>
                    <div className="mt-1">
                        <BoatNameDropdown
                            fields={{
                                name: 'boatId',
                                id: 'boatId',
                                value: filterObj.boatID,
                                onChange: e => {
                                    console.log('onChange', e.target.value)
                                    setFilterObj({
                                        ...filterObj,
                                        boatID: e.target.value,
                                    })
                                },
                            }}
                            purpose="filter"
                            statusCode={null}
                        />
                    </div>
                </div>
                <div className="w-12/12 md:w-4/12">
                    <label htmlFor="country" className="block text-sm font-medium leading-6 text-gray-900">
                        {t('Submitted by')}
                    </label>
                    <div className="mt-1">
                        <UserListDropdown
                            userType={'captain'}
                            fields={{
                                name: 'submittedBy',
                                id: 'submittedBy',
                                value: filterObj.submittedBy,
                                onChange: e => {
                                    console.log('onChange', e.target.value)
                                    setFilterObj({
                                        ...filterObj,
                                        submittedBy: e.target.value,
                                    })
                                },
                            }}
                            purpose="filter"
                            isActive={null}
                        />
                    </div>
                </div>
                <div className="w-12/12 md:w-4/12">
                    <label htmlFor="country" className="block text-sm font-medium leading-6 text-gray-900">
                        {t('Date Range')}
                    </label>
                    <div className="mt-1">
                        <Flatpickr
                            options={{
                                mode: 'range',
                                dateFormat: 'Y-m-d',
                            }}
                            value={[filterObj.dateFrom, filterObj.dateTo]}
                            onChange={date => {
                                setFilterObj({
                                    ...filterObj,
                                    dateFrom: date[0] ? date[0].toLocaleDateString('en-CA').replace(/-/g, '-') : '',
                                    dateTo: date[1] ? date[1].toLocaleDateString('en-CA').replace(/-/g, '-') : '',
                                })
                            }}
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>
                <div className="flex-none grow gap-2 justify-end place-content-end">
                    <button
                        onClick={onClickSearch}
                        type="button"
                        className="inline-flex items-center justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/[0.9]"
                    >
                        {t('Search')}
                    </button>
                    <button
                        onClick={onClickSearchClear}
                        type="button"
                        className="ms-3 inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                        {t('Clear')}
                    </button>
                </div>
            </div>

            <Divider />
            {checkListLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">Loading, please wait...</p>
                </div>
            )}
            {checkListError && (
                <div className="text-center py-24 bg-gray-50 mt-8 rounded-lg">
                    <svg
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        className="mx-auto h-12 w-12 text-gray-400"
                    >
                        <path
                            d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                            strokeWidth={2}
                            vectorEffect="non-scaling-stroke"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <h3 className="mt-2 text-sm font-semibold text-gray-900">{t('Failed to fetch records')}.</h3>
                    <p className="mt-1 text-sm text-gray-500">
                        {t('Please contact the administrator or try again later.')}
                    </p>
                    <div className="mt-6"></div>
                </div>
            )}
            {!checkListLoading && !checkListError && checkLists?.length === 0 && <GraphQlResponseNoData />}
            {!checkListLoading && !checkListError && checkLists?.length > 0 && (
                <>
                    <div className="table-custom flex justify-center items-center bg-white p-0">
                        <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
                            <TableHead>
                                <TableRow>
                                    {/* <TableHeader>Boat ID</TableHeader> */}
                                    <TableHeader>{t('Boat Name')}</TableHeader>
                                    <TableHeader>{t('Boat Number')}</TableHeader>
                                    <TableHeader>{t('Submitted on')}</TableHeader>
                                    <TableHeader>{t('Submitted by')}</TableHeader>
                                    <TableHeader className="flex justify-end">{t('Actions')}</TableHeader>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {checkLists.map(cList => (
                                    <TableRow
                                        key={cList.submission_id}
                                        className="cursor-pointer hover:bg-gray-50"
                                        onClick={() =>
                                            navigate(
                                                `/vessel/checklist/detail/${cList.submission_id}/${cList.audit_info.created_date}`
                                            )
                                        }
                                        title={`checklist #${cList.submission_id}`}
                                    >
                                        <TableCell>{cList.vessel?.boat.name.en}</TableCell>
                                        <TableCell>{cList.vessel?.boat.details.reg_number}</TableCell>
                                        <TableCell>{customDateFormat(cList.submission_date)}</TableCell>
                                        <TableCell>
                                            {cList.captain.user_info.given_name} {cList.captain.user_info.family_name}
                                        </TableCell>

                                        <TableCell className="text-right">
                                            <Dropdown>
                                                <DropdownButton
                                                    plain
                                                    aria-label="More options"
                                                    onClick={e => e.stopPropagation()}
                                                    className="cursor-pointer"
                                                >
                                                    <EllipsisVerticalIcon />
                                                </DropdownButton>
                                                <DropdownMenu anchor="bottom">
                                                    <DropdownItem
                                                        onClick={e => {
                                                            e.stopPropagation()
                                                            navigate(
                                                                `/vessel/checklist/detail/${cList.submission_id}/${cList.audit_info.created_date}`
                                                            )
                                                        }}
                                                    >
                                                        <EyeIcon />
                                                        <DropdownLabel>{t('View')}</DropdownLabel>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                    <Divider />
                    <Pagination className="py-6">
                        <PaginationPrevious
                            onClick={() => handlePageChange(page > 0 ? page - 1 : 0)}
                            disabled={page === 0}
                        />
                        <PaginationList>
                            {getPageRange(page, totalPages).map(index => (
                                <PaginationPage
                                    key={index}
                                    current={index === page}
                                    onClick={() => handlePageChange(index)}
                                >
                                    {index + 1}
                                </PaginationPage>
                            ))}
                        </PaginationList>
                        <PaginationNext
                            onClick={() => handlePageChange(page < totalPages - 1 ? page + 1 : totalPages - 1)}
                            disabled={page === totalPages - 1}
                        />
                    </Pagination>
                    <Divider />
                </>
            )}
            {showErrDialog && (
                <ErrorDialog status={true} title="Error" message={errorMessage} onClose={handleErrClose} />
            )}
            {showSucDialog && (
                <SuccessDialog status={true} title="Success" message={successMessage} onClose={handleErrClose} />
            )}
        </>
    )
}
